<!-- <p>cricital-incidents works!</p> -->

<section class="incident-table-card-content">
  <div class="search-box-container">
    <mat-form-field
      [ngStyle]="
        screenSize != ScreenType.Mobile ? { 'margin-right': '10px' } : {}
      "
      subscriptSizing="dynamic"
      appearance="outline"
    >
      <mat-label>Incident Status</mat-label>

      <mat-select
        [value]="selectedStatus"
        (selectionChange)="onChangeDataTable($event)"
      >
        <mat-option value="-1">All</mat-option>
        <mat-option value="0">Open</mat-option>
        <mat-option value="1">Close</mat-option>
        <mat-option value="2">Verified</mat-option>
        <mat-option value="3">Snooze</mat-option>
        <mat-option value="4">In-progress</mat-option>
        <mat-option value="8">Completed</mat-option>
        <mat-option value="5">On-hold</mat-option>
        <mat-option value="6">Approved</mat-option>
        <mat-option value="7">Rejected</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <div
    *ngIf="
      screenSize == ScreenType.Mobile &&
      filteredDataSource.data.length == 0 &&
      false
    "
    class="no-data-available"
  >
    No Data Available <mat-divider></mat-divider>
  </div>
  <div
    class="visitors-table"
    *ngIf="screenSize != ScreenType.Mobile && !isUserDashboard"
  >
    <!-- <mat-paginator
        [pageSizeOptions]="[10, 25, 100]"
        [pageSize]="10"
        aria-label="Select page of users"
      ></mat-paginator> -->
    <table mat-table [dataSource]="filteredDataSource">
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>No.</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Incident Name
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.incidentName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Date
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.eventCreateDate | date : "full" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Details">
        <th
          style="text-align: center"
          mat-header-cell
          *matHeaderCellDef
          aria-label="row actions"
        >
          Details
        </th>
        <td style="text-align: center" mat-cell *matCellDef="let element">
          <button
            [disabled]="isShowDetails && expandedDetail == element.incidentId"
            (click)="onShowDetails(element)"
            mat-raised-button
          >
            <mat-icon *ngIf="expandedDetail != element.incidentId"
              >add</mat-icon
            >
            <mat-icon
              *ngIf="isShowDetails && expandedDetail == element.incidentId"
              >remove</mat-icon
            >
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="time">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Time
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ getFormatedDate(row.eventCreateDate) | date : "hh:mm a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="asset">
        <th style="border-right: 1px solid" mat-header-cell *matHeaderCellDef>
          Assigned
        </th>
        <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
          {{ row.assignedTo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="evidence">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Evidence
        </th>
        <td
          style="border-right: 1px solid; text-align: center"
          mat-cell
          *matCellDef="let row"
        >
          <img [src]="row.eventEvidence" />
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
        >
          Status
        </th>
        <td
          style="border-right: 1px solid; text-align: center"
          mat-cell
          *matCellDef="let row"
        >
          <!-- [ngStyle]="
                row.security == 'Verified'
                  ? { 'background-color': 'green' }
                  : { 'background-color': 'red' }
              " -->
          <button
            [disabled]="row.incidentStatus == 3"
            (click)="onClickStatus(row)"
            mat-raised-button
            [ngStyle]="
              row.incidentStatus == 3
                ? { 'background-color': '#ffbf00' }
                : row.incidentStatus == 0 || row.incidentStatus == 8
                ? { 'background-color': 'green' }
                : row.incidentStatus == 1
                ? { 'background-color': 'red' }
                : { 'background-color': 'gray' }
            "
          >
            <!-- {{ row.incidentStatus == "3" ? "Snoozed" : ("Snooze" | titlecase) }} -->
            {{
              row.incidentStatus == 1
                ? "Closed"
                : row.incidentStatus == 0
                ? "Open"
                : row.incidentStatus == 2
                ? "Verified"
                : row.incidentStatus == 3
                ? "Snoozed"
                : row.incidentStatus == 4
                ? "In-Progress"
                : row.incidentStatus == 5
                ? "On-Hold"
                : row.incidentStatus == 6
                ? "Approved"
                : row.incidentStatus == 7
                ? "Rejected"
                : row.incidentStatus == 8
                ? "Completed"
                : ("Not Specified" | titlecase)
            }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th
          style="border-right: 1px solid; text-align: center"
          mat-header-cell
          *matHeaderCellDef
          aria-label="row actions"
        ></th>
        <td
          style="border-right: 1px solid; text-align: center"
          mat-cell
          *matCellDef="let element"
        >
          <!-- <button (click)="onShowDetails(element)" mat-raised-button>
              <mat-icon>add</mat-icon>
            </button> -->
          <!-- <button
              [disabled]="element.incidentStatus == '3'"
              (click)="onSnoozeIncident(element)"
              mat-raised-button
            >
              {{ element.incidentStatus == "3" ? "Snoozed" : "Snooze" }}
            </button> -->
        </td>
      </ng-container>
      <tr
        class="table-header"
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <div class="not-matched" *ngIf="!!filteredDataSource && !!temp.length">
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter ""</td>
        </tr>
      </div>
    </table>
    <div class="data-not-found" *ngIf="!temp.length">
      {{ "No Incident Data available" | uppercase }}
    </div>
  </div>
  <div
    class="mobile-table-card"
    *ngIf="screenSize === ScreenType.Mobile || isUserDashboard"
  >
    <app-mobile-table-card
      [incidentTableData]="filtered"
      [tableType]="'incident'"
      (showDetails)="onShowDetails($event)"
      (snoozeIncident)="onClickStatus($event)"
    ></app-mobile-table-card>
  </div>
</section>
